import { h } from 'preact'
import { connect } from 'unistore/preact'
import { BasicDialog } from '@sodra/bongo-ui'
import { goBack } from '@sodra/prutt'

import { deleteColor } from '../../../actions'

const DeleteColor = ({ project, colorId, isUpdatingProject }) => {
  const color = project.colors.find((color) => color.id === colorId)

  const handleSubmit = async () => {
    if (await deleteColor(color.id)) {
      onClose()
    }
  }

  const onClose = () => goBack(`/projects/${project.id}/colors`)

  if (!color) {
    return null
  }

  return (
    <BasicDialog
      disableAutofocus
      title="Ta bort färg"
      primaryActionText="Ta bort"
      primaryActionLoading={isUpdatingProject}
      onPrimaryActionClick={handleSubmit}
      action1Text="Avbryt"
      onAction1Click={onClose}
      onClose={onClose}
    >
      Vill du ta bort färgen?
    </BasicDialog>
  )
}

export default connect('project, isUpdatingProject')(DeleteColor)
